// ---------------------------------------------------------------------------
// Game session phase substates
// ---------------------------------------------------------------------------

export enum ERPlayState {
  Syncing = 'syncing',
  Playing = 'playing',

  // Substates of Playing — map 1:1 to ESessionPhase
  Betting = 'betting',
  Dealing = 'dealing',
  DealingIdle = 'dealingIdle',
  DealingAnimating = 'dealingAnimating',
  Decisions = 'decisions',
  Settlement = 'settlement',
  Finished = 'finished',
}

export enum ERDecisionState {
  WaitingActiveBox = 'waitingActiveBox',
  ActiveBoxReady = 'activeBoxReady',
  ActiveBoxRevealed = 'activeBoxRevealed',
}
